import { version as uuidVersion, validate as uuidValidate } from 'uuid';

export const isUuidV4 = (uuid: string) => uuidValidate(uuid) && uuidVersion(uuid) === 4;

export const uuidRegex = /([0-9a-fA-F]{8}\b-[0-9a-fA-F]{4}\b-[0-9a-fA-F]{4}\b-[0-9a-fA-F]{4}\b-[0-9a-fA-F]{12})/g;
